import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const News = lazy(() => import("@/pages/News"));

export const Route = createFileRoute("/nyheter/")({
  // Hela nyhetslistan från databasen i server-HTML:en, så att alla nyheter
  // länkas från sidan (inte bara de inbyggda).
  loader: async ({ context }) => {
    const [{ newsArticlesQueryOptions }, { archiveLinksLoader }] = await Promise.all([
      import("@/hooks/useContent"),
      import("@/hooks/useScrapedPage"),
    ]);
    // Även de importerade äldre nyheterna (scraped_pages) länkas härifrån.
    const [articles, archive] = await Promise.all([
      context.queryClient.ensureQueryData(newsArticlesQueryOptions()).catch(() => null),
      archiveLinksLoader(context.queryClient, "/nyheter"),
    ]);
    return { articles, archive };
  },
  head: () => seoHead("/nyheter"),
  component: NewsRoute,
});

function NewsRoute() {
  const { articles, archive } = Route.useLoaderData();
  return <News initialArticles={articles} archive={archive} />;
}
